import {IPNSSearch} from '@portal-ng/PNSModels/PNSSearch.model';

export interface IPNSUserSearch extends IPNSSearch {
  searchTerm: string | null;

}
